// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Qj-z","red":"Rj-z","calloutlink":"Sj-z","headerTopBanner":"Tj-z","bgcolorRed":"Uj-z","headerTopCallout":"Vj-z","searchBanner":"Wj-z","hideMobile":"Xj-z"};